/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Folder permissions updated" |
*
* @param {Explorer_Info_Permissions_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_updated_toast = /** @type {((inputs?: Explorer_Info_Permissions_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations du dossier mises a jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnerberechtigungen aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni delle cartelle aggiornate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлены права доступа к папке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos de carpeta actualizados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹权限已更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダの権限が更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर की अनुमतियाँ अपडेट कर दी गईं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões da pasta atualizadas")
	return /** @type {LocalizedString} */ ("Folder permissions updated")
});